import { Svg, theme } from '@redriverpress/system'

export default function Logo(props) {
  return (
    <Svg
      version='1.1'
      viewBox='0 0 213.611 72'
      x='0'
      y='0'
      xmlns='http://www.w3.org/2000/svg'
      xmlSpace='preserve'
      {...props}
    >
      <g>
        <path
          fill={theme.colors.black}
          d='M82.422,20.405c-14.394,0-23.466,9.985-23.466,25.878c0,16.092,9.073,25.204,23.367,25.204
		c8.737,0,16.665-3.606,19.698-12.159c0.254-0.715-0.144-1.494-0.867-1.724l-7.799-2.48c-0.039-0.015-0.078-0.024-0.114-0.036
		c-0.837-0.217-1.081,0.497-1.081,0.497c-1.512,4.863-4.956,7.715-9.738,7.715c-7.197,0-11.536-6.254-11.831-15.27l30.359,0
		c0.607,0,1.146-0.404,1.298-0.992c0.373-1.444,0.684-3.504,0.684-5.503C102.931,29.71,95.93,20.405,82.422,20.405z M91.38,40.237
		c-0.005,0.543-0.08,1.201-0.08,1.201H70.786c0.789-7.754,4.932-12.846,11.44-12.846c6.013,0,9.169,4.996,9.169,10.422
		C91.395,39.367,91.395,39.797,91.38,40.237z'
        />
        <path
          fill={theme.colors.black}
          d='M135.025,68.244l-0.566-4.764c-0.021,0-0.033-0.009-0.036-0.027c-0.157-1.268-1.244-0.943-1.572-0.813
		c-0.024,0.012-0.045,0.018-0.06,0.027c-0.828,0.394-1.644,0.632-2.502,0.632c-2.617,0-3.975-1.358-3.975-4.36V1.69
		c-0.072-1.132-1.024-1.319-1.343-1.349h-9.236c-0.741,0-1.342,0.601-1.342,1.342v57.979c0,8.528,5.33,11.629,11.825,11.629
		c3.052,0,5.955-0.666,8.061-1.677C134.796,69.366,135.093,68.814,135.025,68.244z'
        />
        <path
          fill={theme.colors.black}
          d='M163.731,63.48c-0.021,0-0.033-0.009-0.036-0.027c-0.157-1.268-1.244-0.943-1.572-0.813
		c-0.024,0.012-0.045,0.018-0.06,0.027c-0.828,0.394-1.644,0.632-2.502,0.632c-2.617,0-3.975-1.358-3.975-4.36V1.826
		c0-1.253-1.012-1.451-1.343-1.485h-9.236c-0.741,0-1.342,0.601-1.342,1.342v57.979c0,8.528,5.33,11.629,11.825,11.629
		c3.052,0,5.955-0.666,8.061-1.677c0.517-0.248,0.814-0.801,0.746-1.37L163.731,63.48z'
        />
        <path
          fill={theme.colors.black}
          d='M179.783,0.147c-4.071,0-7.464,2.811-7.464,7.173c0,4.362,3.393,7.173,7.464,7.173s7.56-2.811,7.56-7.173
		C187.344,2.958,183.854,0.147,179.783,0.147z'
        />
        <path
          fill={theme.colors.black}
          d='M184.346,20.321h-9.134c-0.741,0-1.342,0.601-1.342,1.342V68.98c0,0.741,0.601,1.342,1.342,1.342h9.24
		c0.741,0,1.342-0.601,1.342-1.342V21.808C185.794,20.33,184.379,20.321,184.346,20.321z'
        />
        <path
          fill={theme.colors.black}
          d='M210.61,20.321h-9.131c-0.741,0-1.342,0.601-1.342,1.342V68.98c0,0.741,0.601,1.342,1.342,1.342h9.237
		c0.741,0,1.342-0.601,1.342-1.342V21.808h-0.003C212.055,20.33,210.643,20.321,210.61,20.321z'
        />
        <path
          fill={theme.colors.black}
          d='M206.05,14.492c4.071,0,7.56-2.811,7.56-7.173c0-4.362-3.489-7.173-7.56-7.173
		c-4.071,0-7.464,2.811-7.464,7.173C198.587,11.681,201.979,14.492,206.05,14.492z'
        />
        <path
          fill={theme.colors.yellow500}
          d='M49.406,23.543C48.821,10.887,38.559,0.62,25.904,0.028C11.713-0.636,0,10.673,0,24.717
		c0,8.051,3.85,15.202,9.809,19.715c1.311,0.993,2.484,2.169,3.336,3.576c0.698,1.153,1.252,2.389,1.631,3.679
		c0.318,1.083,1.288,1.844,2.417,1.844h15.112c1.128,0,2.098-0.758,2.415-1.84c0.39-1.329,0.965-2.601,1.692-3.783
		c0.856-1.392,2.019-2.562,3.317-3.555C45.915,39.616,49.799,32.023,49.406,23.543z M24.685,40.662c-0.148,0-0.294-0.007-0.44-0.011
		l0.099,5.29c0.014,0.631-0.717,0.989-1.207,0.592l-5.858-5.444c0,0-7.359-6.078-8.189-13.478c-0.162-0.908-0.251-1.841-0.251-2.796
		c0-9.123,7.71-16.446,16.97-15.807c7.814,0.539,14.144,6.869,14.683,14.683C41.131,32.951,33.808,40.662,24.685,40.662z'
        />
        <path
          fill={theme.colors.black}
          d='M31.651,62.394H17.768c-1.324,0-2.398-1.074-2.398-2.398s1.074-2.398,2.398-2.398h13.883
		c1.324,0,2.398,1.074,2.398,2.398S32.975,62.394,31.651,62.394z'
        />
        <g>
          <path
            fill={theme.colors.black}
            d='M24.757,72c3.006,0,5.63-1.584,7.032-3.936c0.428-0.719-0.095-1.619-0.952-1.619h-12.16
			c-0.857,0-1.38,0.9-0.952,1.619C19.128,70.416,21.751,72,24.757,72z'
          />
        </g>
        <circle fill={theme.colors.black} cx='31.353' cy='23.196' r='3.358' />
        <path
          fill={theme.colors.black}
          d='M14.921,25.968c-0.089,0-0.179-0.008-0.27-0.024c-0.836-0.148-1.395-0.946-1.247-1.782
		c0.424-2.401,2.504-4.144,4.944-4.144s4.52,1.743,4.944,4.144c0.148,0.836-0.411,1.634-1.247,1.782
		c-0.829,0.148-1.633-0.409-1.782-1.247c-0.164-0.928-0.97-1.602-1.915-1.602c-0.945,0-1.751,0.674-1.915,1.603
		C16.301,25.444,15.652,25.968,14.921,25.968z'
        />
      </g>
    </Svg>
  )
}
